import { forwardRef } from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import { isNilOrEmpty } from 'packages/core'
import classNames from 'classnames'

export interface IAttributeValueProps {
    className?: string
    children?: any
}

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            fontSize: '12px',
            lineHeight: 1.33,
            color: theme.palette.common.black,
            width: '100%',
            display: 'block',
            wordBreak: 'break-word',
            wordWrap: 'break-word',
            textTransform: 'capitalize',
            padding: theme.spacing(0.5),
        },
    }),
)

export const AttributeValue = forwardRef<any, IAttributeValueProps>(
    (props, ref) => {
        const classes = useStyles()

        return (
            <div
                className={classNames(classes.root, props.className)}
                ref={ref}
            >
                {isNilOrEmpty(props.children) ? '-' : props.children}
            </div>
        )
    },
)
